import { NgModule } from '@angular/core';

import { SharedModule }                             from '../../shared/shared.module';
import { TableModule }                              from '../../table/table.module';
import { TransactionCenterVendorInvoicesComponent } from './transaction-center.vendor-invoices.component';
import { TransactionCenterVendorInvoicesService }   from './transaction-center.vendor-invoices.service';

@NgModule({
  declarations: [
    TransactionCenterVendorInvoicesComponent
  ],
  entryComponents: [
    TransactionCenterVendorInvoicesComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    TransactionCenterVendorInvoicesService
  ]
})
export class TransactionCenterVendorInvoicesModule {}
